import { Component } from '@angular/core';

import { IonicPage, NavController, NavParams,LoadingController,Slides,Events,Platform,AlertController } from 'ionic-angular';
import { DatePicker } from '@ionic-native/date-picker';
import { Http } from '@angular/http';
import { MenuController } from 'ionic-angular';
import { Commontask } from '../../providers/commontask'
import { Webservice } from '../../providers/webservice'
import { Storagehelper } from '../../providers/storagehelper'
import { SocialSharing } from '@ionic-native/social-sharing';
import { LocalNotifications } from '@ionic-native/local-notifications';
import * as moment from 'moment';
var cordova:any;
/**
/**
 * Generated class for the NewreminderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-newreminder',
  templateUrl: 'newreminder.html',
})
export class NewreminderPage extends Commontask {
  public remindersetting;
  public pickedDate;
  public drpupprepa; 
  public saveerror;
  public viewtype;
  public reminderid;
public formattedDate;

   constructor(public navCtrl: NavController, public navParams: NavParams,public menuctrl: MenuController,public http:Http,public webservice:Webservice,public loader:LoadingController,public storage:Storagehelper,public event:Events,public alertCtrl:AlertController,public platform:Platform,public socialShare:SocialSharing,public datePicker:DatePicker,public localnotifcation:LocalNotifications) {
      super(menuctrl,event,platform,socialShare,alertCtrl);
      this.viewtype=this.navParams.get('remindertype');
      this.remindersetting={datetime:"",title:"",upprepa:{value:0,text:"Aldrig"},reminder_id:-1};
      this.drpupprepa=[];
      this.saveerror="";
      this.generateupprepa();

      this.remindersetting.upprepa=this.drpupprepa.filter((e)=>{
              return e.value==0
            })[0];
      this.loadReminder();
      this.pickedDate=new Date();

  }

  loadReminder(){
    if(this.viewtype=="update"){
        this.remindersetting.reminder_id=this.navParams.get("reminderid");
        this.storage.queryStorage("reminders","reminder_id",this.remindersetting.reminder_id).then((data)=>{
            var res:any=data[0];

            let formattedDate=this.getFormattedDate(res.datetitle);
            this.pickedDate=new Date(res.datetitle);
            this.remindersetting.datetime=formattedDate;
            this.remindersetting.title=res.title;
            this.remindersetting.upprepa=this.drpupprepa.filter((e)=>{
              return e.value==res.upprepa
            })[0];
        })
    }
  }

  generateupprepa(){
    this.drpupprepa.push({value:0,text:"Aldrig"})
    this.drpupprepa.push({value:1,text:"Varje dag"})
    this.drpupprepa.push({value:2,text:"Varje vecka"})
  }

  addNewReminder(){
    if(this.validate()){
      this.saveerror="";
      var param={title:this.remindersetting.title,datetitle:this.pickedDate,reminder_id:this.remindersetting.reminder_id,upprepa:this.remindersetting.upprepa.value};
      if(this.viewtype=="create"){
        this.storage.addNewItem("reminders","reminder_id",param).then(()=>{
            this.goback();
            this.scheduleAllReminder();
        })
      }else{
         this.storage.updateItem("reminders","reminder_id",this.remindersetting.reminder_id,param).then(()=>{
            this.goback();
            this.scheduleAllReminder();
        })
      }
    }
     

  }


  private scheduleAllReminder(){
        this.storage.getStorageItem("reminders").then(data=>{
          if(data!=undefined && data.length>0){
            data.forEach((e,i)=>{

              this.unscheduleReminder(this.localnotifcation,e.reminder_id);
              // if(e.upprepa!=0){
                this.scheduleReminder(e.reminder_id,e.title,e.datetitle,e.upprepa);
              // }
            })
          }
        })

  }

  private scheduleReminder(reminder_id,reminderTitle,reminderDateTime,remindertype){
    var datetime=new Date(reminderDateTime);
    var noschedule=false;
    var everySetting="day";
    if(remindertype==2){
      everySetting="week";
      datetime=this.calculateNextDateforWeek(datetime);
    }else if(remindertype==1){
      everySetting="day";
      datetime=this.calculateNextDateforDate(datetime);
    }else{
      everySetting="0";
        var day=datetime.getDay();
        var today=moment();
        var momentDate=moment(datetime);
        var diff=today.isAfter(momentDate);
        if(diff==true){
          noschedule=true;
          return;
        }
    }
    if(noschedule==false){
      datetime.setSeconds(0)
      this.localnotifcation.schedule({
        id: reminder_id,
        text: reminderTitle,
        every:everySetting,
        at:datetime,
        data: { secret: "123456" }
      });

      console.log("Reminder scheduled for "+reminderDateTime);
    }

  }

  public validate(){

    if(this.remindersetting.title==""){
      this.saveerror="Påminnelsetext obligatoriskt";
      return false;
    }else if(this.remindersetting.datetime==""){
      this.saveerror="Välj datum och tid";
      return false;
    } else{
      this.saveerror="";
      return true;
    }

  }

  public pickDateTime(){
    this.datePicker.show({
      date: this.pickedDate,
      mode: 'datetime',
      locale:'sv_SE',
      okText:'OK',
      cancelText:'Avbryt',
      titleText:'Snorkel',
      doneButtonLabel:'Klar',
      cancelButtonLabel:'Avbryt',
      allowOldDates:false,
      androidTheme: this.datePicker.ANDROID_THEMES.THEME_HOLO_DARK
    }).then(
      date => {
        if(date!=undefined){
          this.pickedDate=date;
          this.remindersetting.datetime=date;
          let formattedDate=this.getFormattedDate(date);
          this.remindersetting.datetime=formattedDate;
          console.log('Got date: ', date)
          this.validate();
        }
      },

      err => console.log('Error occurred while getting date: ', err)
    );
  }


 
   ionViewDidEnter(){
    // if(this.audioplayer.src!=""){
    //   this.Play();
    // }
    this.event.publish('app:changeHeaderBackground'); 
  }

  ionViewCanEnter(){

    this.event.publish('app:changeHeaderBackground'); 
  }

  ionViewWillEnter(){
    this.loadReminder();
    this.event.publish('app:changeHeaderBackground'); 
  }

  calculateNextDateforWeek(date:Date){

    var day=date.getDay();
    var today=moment();
    var momentDate=moment(date);
    var diff=today.isAfter(momentDate);
    if(diff==true){
      var newDate=new Date();
      var currentDay = new Date().getDay();
      var daytoset = date.getDay();
      var distance=0;
      if(daytoset>currentDay){
        distance=daytoset-currentDay;
      }else{
        distance=(7-currentDay)+daytoset;
      }
      // distance+=1;
      newDate.setHours(date.getHours());
      newDate.setMinutes(date.getMinutes());
      newDate.setDate(newDate.getDate()+distance);
      newDate.setSeconds(0);
      return newDate;
    }else{
      return date;
    }

  }


  calculateNextDateforDate(date:Date){
    
    var day=date.getDay();
    var today=moment();
    var momentDate=moment(date);
    var diff=today.isAfter(momentDate);
    if(diff==true){

      var daydiff=today.diff(momentDate,'days');
      var newtoday=new Date();
      // if(daydiff==0){
      //   newtoday.setHours(date.getHours());
      //   newtoday.setMinutes(date.getMinutes());
      //   return newtoday;
      // }else{
        newtoday.setDate(date.getDate()+1);
        newtoday.setHours(date.getHours());
        newtoday.setMinutes(date.getMinutes());
        return newtoday;
      // }
    }else{
      return date;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/newreminder/newreminder.ts